import React, { useEffect } from 'react'
import ModalCustom from '../../modal-custom'
import { Button, Col, Form, Row } from 'react-bootstrap'
import { yupResolver } from '@hookform/resolvers/yup'
import * as yup from 'yup'
import { Controller, useForm } from 'react-hook-form'
import LabelCustom from '../../label-custom'
import Error_false from '../../error/error-false'
import SwalCustom from '../../../alert/swal-custom'
import { putHolidayAPI } from '../../../services/holiday'
import DatepickerCustom from '../../datepicker-custom'
import UseTypeHoliday from '../../../hooks/use-type-holiday'
import moment from 'moment'
import { TXTSUCCESS } from '../../../Constants'
import AutocompleteCustom from '../../custom/autocomplete'

const schema = yup
  .object({
    type: yup.object().required('Please, Input type'),
    date: yup.string().required('Please, Input date'),
    detail: yup.string().required('Please, Input detail')
  })
  .required()
export default function EditHoliday({
  setIsSave,
  showCreate,
  isSave,
  setShowCreate,
  detail,
  fnGetData
}) {
  const {
    control,
    setValue,
    setError,
    handleSubmit,
    formState: { errors }
  } = useForm({
    resolver: yupResolver(schema)
  })

  useEffect(() => {
    detail.type_id &&
      setValue('type', {
        label: detail.type_name ?? '',
        value: detail.type_id ?? ''
      })

    setValue('date', detail.date ?? '')

    setValue('detail', detail.detail ?? '')
  }, [detail, setValue])

  const type = UseTypeHoliday()

  const onSubmit = (data) => {
    const body = {
      holidayId: detail.id ?? '',
      holidayTypeId: data.type.value ?? '',
      holidayDate: data.date ?? '',
      holidayDetail: data.detail ?? ''
    }
    SwalCustom({
      title: 'Are you sure?',
      text: 'Do you want to confirm?',
      icon: 'question',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Yes, save it!'
    }).then((result) => {
      if (result.isConfirmed) {
        setIsSave(true)
        putHoliday(body)
        handleClose()
      }
    })
  }

  const putHoliday = async (body) => {
    const data = await putHolidayAPI(body)
    setIsSave(false)
    if (!data) return
    if (data.status) {
      SwalCustom({
        title: `Success!`,
        text: TXTSUCCESS,
        timer: 1500,
        showConfirmButton: false
      }).then(() => {
        fnGetData()
      })
    } else {
      Error_false(data)
    }
  }

  const fnReset = () => {
    setError('levelId', false)
    setError('headTotal', false)
    setError('positionEn', false)
    setError('positionTh', false)
  }

  const handleClose = () => {
    setShowCreate(false)
    fnReset()
  }

  return (
    <ModalCustom width={500} open={showCreate} onCancel={handleClose}>
      <label>Update Holiday</label>

      <Form
        onSubmit={handleSubmit(onSubmit)}
        className="mt-3 row"
        style={{ rowGap: '13px' }}
      >
        <Row style={{ rowGap: '15px' }}>
          <Col md={12}>
            <LabelCustom text={'Type'} />
            <Controller
              name={'type'}
              control={control}
              render={({ field: { onChange, value = '' } }) => (
                <AutocompleteCustom
                  value={value}
                  onChange={onChange}
                  isClearable={false}
                  options={type}
                  className="w-100"
                />
              )}
            />
            {errors.type?.message && (
              <label className="small text-danger">{errors.type.message}</label>
            )}
          </Col>
          <Col md={12}>
            <LabelCustom text={'Date'} />
            <Controller
              name={'date'}
              control={control}
              render={({ field: { onChange, value = '' } }) => (
                <DatepickerCustom
                  clearSearch={false}
                  value={value}
                  onChange={([date]) => {
                    onChange(date ? moment(date).format('YYYY-MM-DD') : '')
                  }}
                />
              )}
            />
            {errors.date?.message && (
              <label className="small text-danger">{errors.date.message}</label>
            )}
          </Col>

          <Col md={12}>
            <LabelCustom text={'Detail'} />
            <Controller
              name="detail"
              control={control}
              render={({ field: { onChange, value = '' } }) => (
                <Form.Control
                  as="textarea"
                  maxLength={250}
                  value={value}
                  onChange={onChange}
                />
              )}
            />

            {errors.detail?.message && (
              <label className="small text-danger">
                {errors.detail.message}
              </label>
            )}
          </Col>

          <Col xl={12} className="text-center ">
            <Button
              className="px-4 me-2 text-white"
              variant="secondary"
              type="button"
              onClick={handleClose}
            >
              {/* Close */}
              Cancel
            </Button>
            <Button type="submit" className="px-4" disabled={isSave}>
              {isSave ? 'Saving...' : 'Save'}
            </Button>
          </Col>
        </Row>
      </Form>
    </ModalCustom>
  )
}
